module.exports = "ENV_URL/Roboto.ttf";